<template>
  <div>
    <v-container class="pa-0 mb-11">
      <!--필수정보 항목-->
      <ValidationObserver ref="form">
        <v-row class="ma-0 pb-1 pb-md-3">
          <v-card-title
            class="pa-0 text-md-h5 text-h6 grey--text text--darken-1 "
          >
            {{ $t("signup.lbl.essential_input") }}
          </v-card-title>
        </v-row>
        <v-row class="pa-0">
          <v-col cols="8">
            <ValidationObserver ref="id">
              <!--persistent-hint는 '사용가능한 아이디입니다' 힌트 메세지가 중복확인 후 focus가 가지않아 처음부터 힌트가 표시되도록 하는 속성-->
              <rx-text-field
                :label="$t('signup.lbl.id')"
                outlined
                placeholder="아이디를 입력해주세요"
                :rules="rules.id"
                v-model="requiredInput.loginId"
                :hint="
                  isUsableId != null && isUsableId.result == false && btnDisable
                    ? $t('signup.msg.available_id')
                    : $t('signup.msg.id_pattern_hint', {
                        patternHint: patternIdHint,
                      })
                "
                persistent-hint
                :dense="$vuetify.breakpoint.smAndUp ? false : true"
                :success="
                  isUsableId != null && isUsableId.result == false
                    ? true
                    : false
                "
                @keyup="checkBtnDisabled"
              >
              </rx-text-field>
            </ValidationObserver>
          </v-col>
          <v-col cols="4" style="position:relative; margin-top: 2px;">
            <rx-btn
              width="100%"
              @click="checkUsableId"
              :x-large="$vuetify.breakpoint.smAndUp ? true : false"
              elevation="0"
              color="secondary"
              :disabled="btnDisable"
            >
              {{ $t("signup.btn.check_id") }}
            </rx-btn>
          </v-col>

          <v-col cols="12">
            <form>
              <rx-text-field
                :label="$t('signup.lbl.pwd')"
                outlined
                placeholder="비밀번호를 입력해주세요"
                :rules="rules.pw"
                v-model="password"
                type="password"
                :hint="
                  authPolicy.passwordPattern.usable
                    ? $t('signup.msg.passsword_pattern_hint', {
                        patternHint: patternHint,
                      })
                    : ''
                "
                hide-details="auto"
                :dense="$vuetify.breakpoint.smAndUp ? false : true"
              >
              </rx-text-field>
            </form>
          </v-col>

          <v-col cols="12">
            <form>
              <rx-text-field
                :label="$t('signup.lbl.pwd_check')"
                outlined
                placeholder="비밀번호를 입력해주세요"
                v-model="pw"
                :rules="rules.pwConfirm"
                type="password"
                hide-details="auto"
                :dense="$vuetify.breakpoint.smAndUp ? false : true"
              >
              </rx-text-field>
            </form>
          </v-col>

          <v-col cols="md-8 6">
            <rx-text-field
              :label="$t('signup.lbl.email')"
              outlined
              :rules="rules.email"
              v-model="emailPre"
              hide-details="auto"
              :suffix="emailSuf === 'directInput' ? null : emailSuf"
              :dense="$vuetify.breakpoint.smAndUp ? false : true"
            >
            </rx-text-field>
          </v-col>

          <v-col cols="md-4 6" margin>
            <rx-combo-box
              comboType="select"
              :extItems="emailSuffix"
              extItemText="label"
              extItemValue="value"
              v-model="emailSuf"
              outlined
              hide-details="auto"
              :clearable="false"
              :dense="$vuetify.breakpoint.smAndUp ? false : true"
            ></rx-combo-box>
          </v-col>

          <v-col cols="12">
            <rx-text-field
              :label="$t('signup.lbl.name')"
              outlined
              :value="identify.name"
              :disabled="!!identify.name"
              :rules="rules.name"
              hide-details="auto"
              :dense="$vuetify.breakpoint.smAndUp ? false : true"
            >
            </rx-text-field>
          </v-col>

          <v-col cols="12">
            <rx-text-field
              :rules="rules.phone_num"
              :label="$t('signup.lbl.phone_num')"
              outlined
              v-model="requiredInput.mobileNo"
              :disabled="
                !!(identifyType === 'KAKAO'
                  ? identify.phone_number
                  : identify.mobileno)
              "
              hide-details="auto"
              :dense="$vuetify.breakpoint.smAndUp ? false : true"
            >
            </rx-text-field>
          </v-col>
          <v-col>
            <v-select
              :label="$t('signup.lbl.gender_code')"
              v-model="requiredInput.genderCode"
              outlined
              hide-details="auto"
              :items="genderCode"
              :disabled="!!identify.gender"
              :menu-props="{ bottom: true, offsetY: true }"
              :dense="$vuetify.breakpoint.smAndUp ? false : true"
            ></v-select>
          </v-col>
          <v-col>
            <rx-date
              :label="$t('signup.lbl.birth_date')"
              v-model="requiredInput.birthDate"
              outlined
              hide-details="auto"
              :disabled="!!requiredInput.birthDate"
              :dense="$vuetify.breakpoint.smAndUp ? false : true"
            ></rx-date>
          </v-col>
        </v-row>
      </ValidationObserver>

      <v-divider class="my-4 my-md-8"></v-divider>
      <!-- 선택정보 항목 -->
      <ValidationObserver ref="form2">
        <v-row class="ma-0 pb-1 pb-md-3">
          <v-card-title
            class="pa-0 text-md-h5 text-h6 grey--text text--darken-1 "
          >
            {{ $t("signup.lbl.select_input") }}
          </v-card-title>
        </v-row>

        <v-row>
          <v-col cols="12" class="pt-0 pb-4">
            <rx-address
              v-model="address"
              outlined
              hide-details
              :dense="$vuetify.breakpoint.smAndUp ? false : true"
              :rules="rules.address"
            ></rx-address>
          </v-col>

          <v-col cols="4" class="py-3 py-sm-4">
            <v-card-text
              class="pa-0 text-subtitle-1 text-sm-h6 grey--text text--darken-3"
            >
              {{ $t("signup.lbl.is_married") }}
            </v-card-text>
          </v-col>
          <v-col cols="8" class="py-3 py-sm-4">
            <v-radio-group
              v-model="isMarried"
              row
              dense
              class="ma-0"
              hide-details="auto"
            >
              <v-radio :label="$t('common.btn.yes')" value="Y"></v-radio>
              <v-radio :label="$t('common.btn.no')" value="N"></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="4" class="py-3 py-sm-4">
            <v-card-text
              class="pa-0 text-subtitle-1 text-sm-h6 grey--text text--darken-3"
            >
              {{ $t("signup.lbl.is_employee") }}
            </v-card-text>
          </v-col>
          <v-col cols="8" class="py-3 py-sm-4">
            <v-radio-group
              v-model="isEmployee"
              row
              dense
              class="ma-0"
              hide-details="auto"
            >
              <v-radio :label="$t('common.btn.yes')" value="Y"></v-radio>
              <v-radio :label="$t('common.btn.no')" value="N"></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="4" class="py-3 py-sm-4">
            <v-card-text
              class="pa-0 text-subtitle-1 text-sm-h6 grey--text text--darken-3"
            >
              {{ $t("signup.lbl.has_child") }}
            </v-card-text>
          </v-col>
          <v-col cols="8" class="py-3 py-sm-4">
            <v-radio-group
              v-model="children"
              row
              dense
              class="ma-0"
              hide-details="auto"
            >
              <v-radio :label="$t('common.btn.yes')" value="Y"></v-radio>
              <v-radio :label="$t('common.btn.no')" value="N"></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="4" class="py-3 py-sm-4">
            <v-card-text
              class="pa-0 text-subtitle-1 text-sm-h6 grey--text text--darken-3"
            >
              {{ $t("signup.lbl.receive_agree") }}
            </v-card-text>
          </v-col>
          <v-col cols="8" class="py-3 py-sm-4">
            <v-checkbox
              :label="$t('signup.lbl.sms_agree')"
              v-model="selectedInput.smsAgree"
              hide-details="auto"
              class="ma-0"
            ></v-checkbox>
            <v-checkbox
              :label="$t('signup.lbl.email_agree')"
              v-model="selectedInput.emailAgree"
              hide-details="auto"
            ></v-checkbox>
            <v-checkbox
              :label="$t('signup.lbl.push_agree')"
              v-model="selectedInput.pushAgree"
              hide-details="auto"
            ></v-checkbox>
            <v-checkbox
              :label="$t('signup.lbl.dm_agree')"
              v-model="selectedInput.dmAgree"
              hide-details="auto"
            ></v-checkbox>
            <v-checkbox
              :label="$t('signup.lbl.tm_agree')"
              v-model="selectedInput.tmAgree"
              hide-details="auto"
            ></v-checkbox>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-container>
  </div>
</template>

<script>
import { ValidationObserver, extend } from "vee-validate";
import RxTextField from "@/redworks/components/base/RxTextField.vue";
import RxBtn from "@/redworks/components/base/RxBtn.vue";
import RxAddress from "@/redworks/components/base/RxAddress.vue";
import { $isUsableLoginId } from "@/redcrm/api/customer.js";
import { $getAccountConfig } from "@/redcrm/api/configs.js";
import i18n from "@/redworks/plugins/i18n";

extend("confirmed", {
  validate(value, { newPassword }) {
    return value === newPassword;
  },
  params: ["newPassword"],
  message: (_, value) => {
    return i18n.t("signup.msg.password_do_not_match", {
      newPassword: value.newPassword,
    });
  },
});
extend("emailCheck", {
  validate(value, { emailSuffix }) {
    if (emailSuffix.suffix !== "directInput") {
      value += emailSuffix.suffix;
    }
    const regex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
    if (!regex.test(value)) {
      return i18n.t("signup.msg.not_email_pattern");
    } else {
      return true;
    }
  },
  params: ["emailSuffix"],
});

extend("passwordPattern", {
  validate(value, args) {
    // 1. 공백 체크
    const spaceRegex = new RegExp("\\s");
    if (spaceRegex.test(value)) {
      return false;
    } else {
      // 2. 패턴 값 포함 여부
      return args.patternRegex.test(value);
    }
  },
  params: ["patternRegex", "patternHint"],
  message: (_, value) => {
    return i18n.t("signup.msg.passsword_pattern_hint", {
      patternHint: value.patternHint,
    });
  },
});
extend("idPattern", {
  validate(value, args) {
    // 1. 공백 체크
    const spaceRegex = new RegExp("\\s");
    if (spaceRegex.test(value)) {
      return false;
    } else {
      // 2. 패턴 값 포함 여부
      return args.patternRegex.test(value);
    }
  },
  params: ["patternRegex", "patternHint"],
  message: (_, value) => {
    return i18n.t("signup.msg.id_pattern_hint", {
      patternHint: value.patternHint,
    });
  },
});

export default {
  computed: {
    rules() {
      return {
        id: {
          required: true,
          max: 20,
          idPattern: {
            patternRegex: this.makeIdPattern(),
            patternHint: this.makeIdPatternHint(),
          },
        },
        pw: {
          required: true,
          max: 20,
          passwordPattern: {
            patternRegex: this.makePattern(),
            patternHint: this.makePatternHint(),
          },
        },
        name: {
          required: true,
        },
        email: {
          required: true,
          max: 20,
          emailCheck: {
            suffix: this.emailSuf,
          },
        },
        phone_num: {
          required: true,
        },
        pwConfirm: {
          required: true,
          confirmed: {
            newPassword: this.password,
          },
        },
        address: {
          max: 30,
        },
      };
    },
    patternHint() {
      return this.makePatternHint();
    },
    patternIdHint() {
      return this.makeIdPatternHint();
    },
  },
  props: {
    identify: {
      type: Object,
      required: true,
    },
    identifyType: String,
    termsList: Array,
    requiredInput: Object,
    selectedInput: Object,
  },
  components: { ValidationObserver, RxTextField, RxBtn, RxAddress },
  data() {
    return {
      authPolicy: {
        passwordPattern: {
          usable: true,
          includeUpperCase: true,
          includeDigit: true,
          includeSymbolic: true,
          validateMinLength: true,
          minLength: 0,
        },
        idPattern: {
          phoneNum: true,
          email: true,
          lowEnNumNoSymbolic: true,
        },
      },
      marketTerms: {},
      isMarried: "N",
      isEmployee: "N",
      children: "N",
      emailPre: "",
      emailSuf: "directInput",
      address: {},
      pw: "",
      id: "",
      password: "",
      isUsableId: null,
      btnDisable: true,
      emailSuffix: [
        { value: "@naver.com", label: "@naver.com" },
        { value: "@hanmail.net", label: "@hanmail.net" },
        { value: "@daum.net", label: "@daum.net" },
        { value: "@gmail.com", label: "@gmail.com" },
        { value: "@hotmail.com", label: "@hotmail.com" },
        { value: "directInput", label: "직접 입력" },
      ],
      genderCode: [
        { value: "M", text: this.$t("signup.lbl.male") },
        { value: "F", text: this.$t("signup.lbl.female") },
      ],
    };
  },
  methods: {
    async getAccountConfig() {
      try {
        const { data } = await $getAccountConfig();
        const pw = JSON.parse(data.result.configVal);
        const pwConfig = pw.passwordPattern;
        const idConfig = pw.idPattern;
        this.authPolicy.passwordPattern = pwConfig;
        this.authPolicy.idPattern = idConfig;
      } catch {
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
      }
    },
    async validate() {
      return (
        (await this.$refs.form.validate()) &&
        (await this.$refs.form2.validate())
      );
    },
    signupCustomer() {
      if (this.isUsableId == null) {
        this.$rxSnackbar("warning", this.$t("signup.msg.id_confirm"));
        return;
      }
      if (this.isUsableId.result == true) {
        this.$rxSnackbar("warning", this.$t("signup.msg.id_confirm"));
        return;
      }
      if (this.isUsableId.id != this.requiredInput.loginId) {
        this.$rxSnackbar("warning", this.$t("signup.msg.id_confirm"));
        return;
      }

      if (this.identifyType == "KAKAO") {
        this.requiredInput.birthDate =
          this.identify.birthyear + this.identify.birthday;

        if (this.emailSuf === "directInput") {
          this.requiredInput.email = this.emailPre;
        } else {
          this.requiredInput.email = this.emailPre + this.emailSuf;
        }

        this.requiredInput.custName = this.identify.name;
        this.requiredInput.verifyIdSrc = this.identifyType;
        this.requiredInput.verifyIdVal = this.identify.ci;
      } else if (this.identifyType == "NICE") {
        if (this.identify.nationalinfo == 0) {
          this.selectedInput.foreigner = false;
        } else {
          this.selectedInput.foreigner = true;
        }
        this.requiredInput.verifyIdVal = this.identify.ci;
        this.requiredInput.birthDate = this.identify.birthdate;
        this.requiredInput.custName = this.identify.name;
        this.requiredInput.mobileNo = this.identify.mobileno;
        this.requiredInput.verifyIdSrc = this.identifyType;
        this.requiredInput.email = this.emailPre + this.emailSuf;
      }
      if (this.address.zonecode === undefined) {
        this.address.zonecode = "";
      }
      this.selectedInput.zipCode = this.address.zonecode;

      if (this.address.roadAdd === undefined) {
        this.address.roadAdd = "";
      }
      if (this.address.detail === undefined) {
        this.address.detail = "";
      }
      this.selectedInput.address1 = this.address.roadAdd;
      this.selectedInput.address2 = this.address.detail;
      if (this.isMarried == "Y") {
        this.selectedInput.married = true;
      } else {
        this.selectedInput.married = false;
      }
      if (this.isEmployee == "Y") {
        this.selectedInput.employee = true;
      } else {
        this.selectedInput.employee = false;
      }
      if (this.children == "Y") {
        this.selectedInput.hasChildren = true;
      } else {
        this.selectedInput.hasChildren = false;
      }

      this.requiredInput.loginPw = this.CryptoJS.SHA256(this.password).toString(
        this.CryptoJS.enc.Hex
      );

      return Object.assign(this.requiredInput, this.selectedInput);
    },
    getEmailPrefix(email) {
      const userEmailSuf = "@" + email.split("@")[1];

      if (email) {
        const existSuf = this.emailSuffix.find((x) => x.value == userEmailSuf);
        if (existSuf == null) {
          return email;
        }
      }
      return email ? email.split("@")[0] : "";
    },
    getEmailSuffix(email) {
      const userEmailSuf = "@" + email.split("@")[1];

      if (email) {
        if (this.emailSuffix.find((x) => x.value == userEmailSuf)) {
          return userEmailSuf;
        }
      }

      return "directInput";
    },
    async checkUsableId() {
      try {
        const { data } = await $isUsableLoginId(this.requiredInput.loginId);
        this.isUsableId = {
          id: this.requiredInput.loginId,
          result: data.result,
        };

        if (this.isUsableId.result == false) {
          this.btnDisable = true;
        } else {
          this.$rxSnackbar("error", this.$t("signup.msg.exist_id"));
        }
      } catch (error) {
        if (error.response.data.messageCode === "400-1") {
          this.$rxSnackbar("warning", this.$t("signup.msg.not_invalid_id"));
        } else if (error.response.data.status == "404") {
          this.$rxSnackbar("error", this.$t("signup.msg.id_input"));
        }
      }
    },
    identifyChange(identifyType) {
      //유저 정보가 들어올때 형태가 다른 부분 변경
      if (identifyType == "KAKAO") {
        this.emailPre = this.getEmailPrefix(this.identify.email);
        this.emailSuf = this.getEmailSuffix(this.identify.email);
        const str = this.identify.phone_number;
        const regex = /\+\d{2}\s/;
        const replaceStr = str.replace(regex, "0").replace(/-/gi, "");
        this.requiredInput.mobileNo = replaceStr;
        this.requiredInput.genderCode = this.identify.gender
          .charAt(0)
          .toUpperCase();
        this.requiredInput.birthDate = this.changeDateFormat(
          this.identify.birthyear + this.identify.birthday
        );
      } else if (identifyType == "NICE") {
        this.requiredInput.mobileNo = this.identify.mobileno;
        if (this.identify.gender === "0") {
          this.requiredInput.genderCode = "F";
        } else if (this.identify.gender === "1") {
          this.requiredInput.genderCode = "M";
        }
        this.requiredInput.birthDate = this.changeDateFormat(
          this.identify.birthdate
        );
      }
    },
    makePattern() {
      const digitRegex = new RegExp("(?=.*\\d)");
      const lowcaseRegex = `(?=.*[a-z])`;
      const uppercaseRegex = new RegExp("(?=.*[A-Z])");
      const symbolicRegex = new RegExp(
        `(?=.*[/?<>{}[\\]{}();:\`'\\\\"|=+!@#$%,~^&.*\\_-])`
      );

      const passwordPattern = this.authPolicy.passwordPattern;
      let regexStr = new RegExp(lowcaseRegex);
      // 패스워드 패턴 사용 시
      if (passwordPattern.usable) {
        if (passwordPattern.includeUpperCase) {
          // 대문자 포함 형식 추가
          regexStr = new RegExp(regexStr.source + uppercaseRegex.source);
        }
        if (passwordPattern.includeDigit) {
          // 숫자 포함
          regexStr = new RegExp(regexStr.source + digitRegex.source);
        }
        if (passwordPattern.includeSymbolic) {
          // 특수 문자
          regexStr = new RegExp(regexStr.source + symbolicRegex.source);
        }
        if (passwordPattern.validateMinLength) {
          // 자리수 체크
          regexStr = new RegExp(
            regexStr.source + `.{${passwordPattern.minLength},}`
          );
        } else {
          regexStr = new RegExp(regexStr.source + `.{1,}`);
        }
      }
      return regexStr;
    },
    makeIdPattern() {
      const enNumRegex = /^(?=.*[a-z])(?=.*\d)[a-z\d]/;
      const uppercaseRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]/;

      const idPattern = this.authPolicy.idPattern;

      let regexStr = new RegExp(enNumRegex.source);

      if (idPattern.includeUpperCase) {
        regexStr = new RegExp(uppercaseRegex.source);
      }

      if (idPattern.validateMinLength) {
        // 자리수 체크
        regexStr = new RegExp(regexStr.source + `{${idPattern.minLength},}$`);
      } else {
        regexStr = new RegExp(regexStr.source + `{1,}$`);
      }

      return regexStr;
    },

    makePatternHint() {
      const passwordPattern = this.authPolicy.passwordPattern;
      // 패스워드 패턴 사용 시
      let patterns = [this.$t("common.lbl.lower_case")];
      if (passwordPattern.usable) {
        if (passwordPattern.validateMinLength) {
          // 자리수 체크
          patterns.push(
            this.$t("common.lbl.at_least", [passwordPattern.minLength])
          );
        }
        if (passwordPattern.includeUpperCase) {
          // 대문자 포함 형식 추가
          patterns.push(this.$t("common.lbl.upper_case"));
        }
        if (passwordPattern.includeDigit) {
          // 숫자 포함
          patterns.push(this.$t("common.lbl.digit"));
        }
        if (passwordPattern.includeSymbolic) {
          // 특수 문자
          patterns.push(this.$t("common.lbl.symbols"));
        }
      }
      let hint = "";
      if (patterns.length > 0) {
        patterns.forEach((pattern, i) => {
          if (i > 0) {
            hint = hint.concat("/");
          }
          hint = hint.concat(pattern);
        });
      }
      return hint;
    },
    makeIdPatternHint() {
      const idPattern = this.authPolicy.idPattern;
      let patterns = [this.$t("signup.msg.lowen_num_nosymbolic")];

      if (idPattern.validateMinLength) {
        // 자리수 체크
        patterns.push(this.$t("common.lbl.at_least", [idPattern.minLength]));
      }
      if (idPattern.includeUpperCase) {
        // 영문대문자
        patterns.push(this.$t("common.lbl.upper_case"));
      }

      let hint = "";
      if (patterns.length > 0) {
        patterns.forEach((pattern, i) => {
          if (i > 0) {
            hint = hint.concat("/");
          }
          hint = hint.concat(pattern);
        });
      }
      return hint;
    },
    async checkBtnDisabled() {
      const id = await this.$refs.id.validate();

      if (id) {
        this.btnDisable = false;
      } else {
        this.btnDisable = true;
      }
      if ((this.isUsableId || {}).id == this.requiredInput.loginId) {
        this.btnDisable = true;
      }
    },
    /**
     * 날짜값 변환
     * @param {} date
     */
    changeDateFormat(date) {
      if (date) {
        return this.$moment(date, "YYYYMMDD").format("YYYY-MM-DD");
      }
      return null;
    },
  },
  async mounted() {
    if (this.identifyType != null) {
      this.identifyChange(this.identifyType);
      await this.getAccountConfig();
      this.marketTerms = (this.termsList || []).find(
        (terms) => terms.termsCode == "MARKET_TERMS"
      );

      //마켓팅 약관 동의가 false일때 수신동의 false
      if (this.marketTerms != null) {
        if (
          this.marketTerms.agreed == false ||
          this.marketTerms.agreed == null
        ) {
          this.selectedInput.smsAgree = false;
          this.selectedInput.emailAgree = false;
          this.selectedInput.pushAgree = false;
          this.selectedInput.dmAgree = false;
          this.selectedInput.tmAgree = false;
        }
      }
    }
  },
};
</script>

<style></style>
